import { useFormContext, Controller } from 'react-hook-form';
import { CrossInCircleIcon } from '@components/common/Icons/CrossInCircleIcon';
import { TickInCircleIcon } from '@components/common/Icons/TickInCircleIcon';
import { Select } from '@components/common/Select/Select';
import { ISelectOption } from '../Select/types';
import { inputHelperClassName } from '../formControlStyles';
import { IFormSelectProps } from './types';

export const FormSelect: React.FC<IFormSelectProps> = ({
  className,
  name,
  rules,
  options,
  selectProps,
  selectInputProps,
  isDisabled,
  onChangeEffect,
  shouldShowAdornment = false,
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      rules={rules}
      name={name}
      control={control}
      render={props => {
        const isError = Boolean(props.fieldState.error);
        const isInteracted =
          props.fieldState.isDirty || props.fieldState.isTouched || props.field.value !== null || isError;
        const endAdornment = isInteracted ? isError ? <CrossInCircleIcon /> : <TickInCircleIcon /> : null;
        const selectId =
          typeof selectInputProps.label === 'string'
            ? selectInputProps.label.toLowerCase().replace(/[^a-z0-9]+/g, '-')
            : name;

        return (
          <div className={className}>
            <Select
              id={selectId}
              className={'w-full'}
              label={selectInputProps.label}
              disableClearable={selectProps?.disableClearable ?? true}
              options={options}
              value={props.field.value ?? null}
              placeholder={selectInputProps.placeholder as string | undefined}
              onChange={(_event: React.ChangeEvent<HTMLSelectElement>, option: ISelectOption | null) => {
                onChangeEffect && onChangeEffect();
                if (option == null) {
                  return props.field.onChange(null);
                }
                return props.field.onChange(option.value);
              }}
              disabled={isDisabled}
              popupClassName={selectProps?.popupClassName}
              suffixIcon={
                shouldShowAdornment && endAdornment ? (
                  <span className={'inline-flex items-center gap-2'}>{endAdornment}</span>
                ) : undefined
              }
              status={isError ? 'error' : undefined}
              groupBy={selectProps?.groupBy}
              showSearch={selectProps?.showSearch ?? false}
              allowClear={selectProps?.allowClear}
              data-testid={selectProps?.['data-testid']}
            />
            {props.fieldState.error?.message ? (
              <p className={inputHelperClassName}>{props.fieldState.error.message}</p>
            ) : null}
          </div>
        );
      }}
    />
  );
};
